<template>
  <div
    class="user-appearance ursetappr"
    tabindex="0"
    @keydown.prevent.space
  >
    <TabsContentTemplate
      tab="colors"
      :sections="sections"
      style="
        --right-oveflow-x: var(--set-oveflow-x);
        --right-oveflow-y: var(--set-oveflow-y);
        --max-content-width: unset;
        --content-direction: row;
      "
    >
      <template #content_colors>
        <div class="d-flex mh-0">
          <div class="ursetappr_block ursetappr_block_normal ursetappr_block_scroll f-column">
            <GwTitleTooltip
              :title="$t('settings.actions')"
              :tooltip="$t('tooltips.action_colors')"
              class="theme-block-title"
            />
            <SettingsColors :colorList="actionsColors" />

            <div class="theme-block-title mt-4">
              {{ $t('settings.other') }}
            </div>
            <SettingsColors :colorList="otherColors" />

            <GwTitleTooltip
              class="mt-4 theme-block-title"
              :title="$t('settings.player')"
              :tooltip="$t('tooltips.color_player')"
            />
            <SettingsColors :colorList="ipOopColors" />
          </div>
          <div class="ursetappr_block_preview bl-grey">
            <div class="text-small uppercase clr-grey pb-2">
              {{ $t('common.preview') }}
            </div>
            <div class="text-small clr-grey pb-2">
              {{ $t('settings.actions') }}
            </div>
            <div
              class="d-flex f-wrap ursetappr_preview"
              style="grid-gap: 0.25rem"
            >
              <div class="appr-ra_table cursor-paint no-events t-left">
                <div
                  v-for="(s, idx) in rangeTableMock"
                  :key="`${idx}_l`"
                  class="appr-rtc_local"
                  :style="s.s"
                ></div>
              </div>
            </div>

            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.other') }}
            </div>
            <div class="d-flex f-wrap ursetappr_preview">
              <div class="ursetappr_rtc-container d-flex">
                <RangeTableCell
                  class="no-events ursetappr_rtc"
                  :combos="rangeTableCell"
                  :asEmpty="false"
                  :combosPlayer="rangeTableCell"
                  :isCentered="false"
                  :grouping="'none'"
                  player="0"
                  rangeKey="range_normalized"
                  showProp="range"
                  valueProp="range"
                  :solProps="rtcSolProps"
                />
                <RangeTableCell
                  class="no-events ursetappr_rtc"
                  :combos="rangeTableCell"
                  :combosPlayer="rangeTableCell"
                  :useHex="false"
                  :isCentered="false"
                  :grouping="'none'"
                  :noValue="!showHandValue"
                  player="0"
                  rangeKey="range_normalized"
                  valueProp="eq"
                  showProp="eq"
                  :solProps="rtcSolProps"
                />
              </div>
            </div>

            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.player') }}
            </div>
            <div class="d-flex f-wrap ursetappr_preview ursetappr_preview_black">
              <div
                style="background: var(--clr-black-0); position: relative; border-radius: 8px"
                class="h-100 w-100 pa-2"
              >
                <ChartLegendPlayers
                  style="left: 0.5rem"
                  :oopPlayer="{ position: 'BB', is_hero: true }"
                  :ipPlayer="{ position: 'BTN', is_hero: false }"
                />
                <svg viewBox="0 0 844 309">
                  <g style="z-index: 0">
                    <path
                      d="M 0,267.526976355 C 0,267.526976355 64.90384275127663,197.969369439 64.90384275127663,197.969369439 C 64.90384275127663,197.969369439 222.66091700990432,177.21429027 222.66091700990432,177.21429027 C 222.66091700990432,177.21429027 353.9792864226083,144.960625542 353.9792864226083,144.960625542 C 353.9792864226083,144.960625542 536.1851301696507,98.94817590600005 536.1851301696507,98.94817590600005 C 536.1851301696507,98.94817590600005 844,63.69179348099999 844,63.69179348099999 C 844,63.69179348099999 844,63.69179348099999 844,63.69179348099999"
                      class="path"
                      style="
                        z-index: 0;
                        position: relative;
                        fill: transparent;
                        stroke: var(--clr-player_ip);
                        stroke-width: 3;
                      "
                    ></path>
                  </g>
                  <g style="z-index: 1">
                    <path
                      d="M 0,281.0780809192 C 0,281.0780809192 156.59300563857002,224.04149132999999 156.59300563857002,224.04149132999999 C 156.59300563857002,224.04149132999999 239.04441046718443,213.322311303 239.04441046718443,213.322311303 C 239.04441046718443,213.322311303 378.73731488978916,189.76267922699998 378.73731488978916,189.76267922699998 C 378.73731488978916,189.76267922699998 700.5267570501072,117.62285942700001 700.5267570501072,117.62285942700001 C 700.5267570501072,117.62285942700001 844,95.42389092900001 844,95.42389092900001 C 844,95.42389092900001 844,95.42389092900001 844,95.42389092900001"
                      class="path"
                      style="
                        z-index: 0;
                        position: relative;
                        fill: transparent;
                        stroke: var(--clr-player_oop);
                        stroke-width: 3;
                      "
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #content_cards>
        <div class="d-flex mh-0">
          <div class="ursetappr_block ursetappr_block_normal ursetappr_block_scroll f-column">
            <GwTitleTooltip
              class="theme-block-title"
              :title="$t('settings.suits_colors')"
              :tooltip="$t('tooltips.suits_colors')"
            />
            <SettingsColors
              :colorList="suitsColors"
              :hiddenColors="['card_back']"
            />
            <SettingsCardsStyle
              class="mt-4"
              :hasBack="false"
            />
            <SettingsCardsStyle
              class="mt-4"
              :hasFront="false"
            />
          </div>
          <div class="ursetappr_block_preview bl-grey">
            <div class="text-small uppercase clr-grey pb-2">
              {{ $t('common.preview') }}
            </div>
            <div class="text-small clr-grey pb-2">
              {{ $t('settings.cards_preview') }}
            </div>
            <div class="f-column ursetappr_preview">
              <div
                v-for="size in ['large', 'small', 'mini']"
                :key="size"
                class="appr-cards-rows mb-4"
              >
                <div class="appr-pack-row">
                  <PokerCard
                    v-for="(card, index) in ['Ad', 'Kd', 'Qs', 'Js', 'Ac', 'Kc', 'Qh', 'Jh']"
                    :key="index"
                    :hasAnimation="false"
                    :card="card"
                    :size="size"
                  ></PokerCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #content_trainer>
        <div class="d-flex mh-0">
          <NavBox style="min-width: 22.5rem; min-height: 32rem">
            <template #root="v">
              <div class="ursetappr_appearance_left">
                <GwTitleTooltip
                  :title="$t('common.trainer_themes')"
                  :tooltip="$t('tooltips.trainer_color_themes')"
                  class="theme-block-title"
                >
                </GwTitleTooltip>
                <ColorPalettes
                  :hasImport="false"
                  :onlyTrainer="true"
                  :hasEdit="true"
                  :customPalleteKey="'customPalleteTrainer'"
                  class="ursetappr_right_item"
                  @click:pencil="v.goForward('trainer_theme')"
                />
              </div>
            </template>
            <template #trainer_theme="v">
              <div class="d-flex mh-0">
                <div
                  class="ursetappr_block ursetappr_block_normal ursetappr_block_scroll f-column pt-0"
                >
                  <div
                    class="d-flex w-100 icon_btn_cont_hover clr-grey"
                    style="
                      position: sticky;
                      top: 0;
                      z-index: 4;
                      background: var(--clr-black-1);
                      padding: 0.75rem 0 0.5rem 0;
                    "
                    @click="v.goBackward('root')"
                  >
                    <div class="mdi mdi-arrow-left icon_btn text-normal pa-1"></div>
                    <div class="my-auto ml-2 clr-grey text-small">
                      {{ $t('common.back_to_themes') }}
                    </div>
                  </div>

                  <div class="flex-1">
                    <GwTitleTooltip
                      :title="$t('settings.trainer_poker_player')"
                      :tooltip="$t('tooltips.trainer_poker_player_colors')"
                    />
                    <SettingsColors
                      :colorList="trainerTableColors"
                      :enabledColors="[
                        'trainer_player_hero',
                        'trainer_player_opponent',
                        'trainer_player_active',
                        'trainer_player_folded',
                      ]"
                    />
                  </div>
                  <div class="flex-1 mt-4">
                    <GwTitleTooltip
                      :title="$t('settings.trainer_table')"
                      :tooltip="$t('tooltips.poker_table_trainer_colors')"
                    />
                    <SettingsColors
                      :colorList="trainerTableColors"
                      :hiddenColors="[
                        'trainer_active_canvas_back',
                        'trainer_active_canvas_outline',
                        'trainer_active_table_back',
                        'trainer_active_table_outline',
                        'trainer_player_hero',
                        'trainer_player_opponent',
                        'trainer_player_active',
                        'trainer_player_folded',
                        'trainer_pattern',
                        'trainer_hand_highlight',
                        'trainer_action_btn_default_background',
                      ]"
                    />
                  </div>

                  <div
                    v-if="!mobile"
                    class="flex-1 mt-4"
                  >
                    <GwTitleTooltip
                      :title="$t('settings.trainer_table_active')"
                      :tooltip="$t('tooltips.poker_table_trainer_colors_active')"
                    />
                    <SettingsColors
                      :colorList="trainerTableColors"
                      :enabledColors="[
                        'trainer_active_canvas_back',
                        'trainer_active_canvas_outline',
                        'trainer_active_table_back',
                        'trainer_active_table_outline',
                      ]"
                    />
                  </div>

                  <div class="flex-1 mt-4">
                    <GwTitleTooltip :title="$t('settings.other')" />
                    <SettingsColors
                      :colorList="trainerTableColors"
                      :enabledColors="['trainer_hand_highlight']"
                    />
                    <SettingsColors
                      :colorList="trainerTableColors"
                      :enabledColors="['trainer_action_btn_default_background']"
                    />
                  </div>
                  <div class="flex-1 mt-4">
                    <SettingsTrainerBackPattern />
                  </div>
                </div>
              </div>
            </template>
          </NavBox>
          <div
            class="ursetappr_block_preview bl-grey"
            style="padding: 1rem 2rem"
          >
            <div
              class="text-small uppercase clr-grey pb-2"
              style="position: relative; left: -1rem"
            >
              {{ $t('common.preview') }}
            </div>
            <div
              class="text-small clr-grey pb-2"
              style="position: relative; left: -1rem"
            >
              {{ $t('settings.trainer_table') }}
            </div>
            <div class="ursetappr_trainer-container ursetappr_previewx">
              <TrainerBackPattern class="appearance-trainer-pattern" />
              <PokerTableSkeleton
                :players="l_players"
                class="table-appearance"
                style="f"
                :style="`
              font-size: 8px;
              --cards-space: 0px;
              --table-hor-min-height: 100%;
              --clr-table-back: var(--clr-trainer_table_back);
              --clr-table-outline: var(--clr-trainer_table_outline);
            `"
              >
                <template
                  v-for="player in l_players"
                  #[player.position]
                  :key="player.position"
                >
                  <slot :name="`${player.position}_before`" />
                  <PokerPlayer
                    :player="player"
                    :hasStack="false"
                    :hasCards="false"
                    :style="`
                  --clr-player-primary:var(--clr-hero);
                  --clr-player-stroke: var(--clr-trainer_player_active);
                  --clr-player-stroke-folded: var(--clr-trainer_player_folded);
                  `"
                  >
                    <template #[player.position]>
                      <slot :name="player.position" />
                    </template>
                  </PokerPlayer>
                </template>
              </PokerTableSkeleton>
            </div>

            <div v-if="!mobile">
              <div
                class="text-small clr-grey pb-2 mt-6"
                style="position: relative; left: -1rem"
              >
                {{ $t('settings.trainer_table_active') }}
              </div>
              <div
                class="ursetappr_trainer-container ursetappr_trainer-container_active ursetappr_previewx"
              >
                <TrainerBackPattern class="appearance-trainer-pattern" />
                <PokerTableSkeleton
                  :players="l_players"
                  class="table-appearance"
                  style="f"
                  :style="`
              font-size: 8px;
              --cards-space: 0px;
              --table-hor-min-height: 100%;
              --clr-table-back: var(--clr-trainer_active_table_back);
              --clr-table-outline: var(--clr-trainer_active_table_outline);
            `"
                >
                  <template
                    v-for="player in l_players"
                    #[player.position]
                    :key="player.position"
                  >
                    <slot :name="`${player.position}_before`" />
                    <PokerPlayer
                      :player="player"
                      :hasStack="false"
                      :hasCards="false"
                      :style="`
                  --clr-player-primary:var(--clr-hero);
                  --clr-player-stroke: var(--clr-trainer_player_active);
                  --clr-player-stroke-folded: var(--clr-trainer_player_folded);
                  `"
                    >
                      <template #[player.position]>
                        <slot :name="player.position" />
                      </template>
                    </PokerPlayer>
                  </template>
                </PokerTableSkeleton>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #content_preferred_seat>
        <div
          class="ursetappr_block"
          style="overflow-x: hidden; overflow-y: auto; width: 45rem; padding: 1rem 1rem 2rem 1rem"
        >
          <SettingsHeroTableSeats />
        </div>
      </template>
      <template #content_text_and_backgrounds>
        <div class="d-flex mh-0">
          <div class="ursetappr_block ursetappr_block_normal ursetappr_block_scroll f-column">
            <div class="f-column">
              <GwTitleTooltip
                class="theme-block-title"
                :title="$t('settings.text_shadow_action_btn')"
                :tooltip="$t('tooltips.text_shadow_action_btn')"
              />
              <SettingsTextOutline propKey="actionBtnShadowStyle" />
              <SettingsColors
                class="mt-2"
                :colorList="typographyColors"
                :enabledColors="['action_text']"
              />
            </div>
            <div class="f-column mt-4">
              <div class="flex-1">
                <GwTitleTooltip
                  class="theme-block-title"
                  :title="$t('common.range_table_cell')"
                  :tooltip="$t('tooltips.range_table_cell')"
                />

                <SettingsCheckbox
                  class="ursetappr_right_item my-1"
                  settingsKey="showHandValue"
                  style="padding-left: 0.125rem"
                  :title="$t('settings.show_hand_value')"
                  :tooltip="$t('tooltips.strategy_combo_with_value')"
                />
                <SettingsColors
                  class="mt-2"
                  :colorList="typographyColors"
                  :enabledColors="['range_text', 'range_active', 'range_empty']"
                />
              </div>

              <GwTitleTooltip
                class="mt-6 theme-block-title"
                :title="$t('settings.text_shadow')"
                :tooltip="$t('tooltips.text_shadow')"
              />
              <SettingsTextOutline
                class="ursetappr_right_item"
                style="padding-left: 0.125rem"
                propKey="rangeCellShadowStyle"
              />
            </div>

            <div class="f-column mt-4">
              <div class="flex-1">
                <GwTitleTooltip
                  class="mt-2 theme-block-title"
                  :title="$t('common.hand_table_cell')"
                  :tooltip="$t('tooltips.text_shadow')"
                />
                <SettingsColors
                  :colorList="typographyColors"
                  :enabledColors="['combo_text', 'combo_range_active', 'combo_range_empty']"
                />
              </div>
            </div>
          </div>
          <div class="ursetappr_block_preview bl-grey">
            <div class="text-small uppercase clr-grey pb-2">
              {{ $t('common.preview') }}
            </div>
            <div class="text-small clr-grey pb-2">
              {{ $t('settings.text_shadow_action_btn') }}
            </div>
            <div class="d-flex ursetappr_preview">
              <div
                v-for="item in [
                  ['Raise', `--clr-R_default`],
                  ['Call', `--clr-C`],
                  ['Check', `--clr-X`],
                  ['Fold', `--clr-F`],
                ]"
                :key="item[0]"
                :style="`--clr-back: var(${item[1]})`"
                class="appr-mocked-action-btn mr-2"
              >
                {{ item[0] }}
              </div>
            </div>

            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('common.range_table_cell') }}
            </div>
            <div class="ursetappr_rtc-container ursetappr_preview">
              <div class="ursetappr_rtc-container f-column">
                <RangeTableCell
                  class="no-events ursetappr_rtc"
                  :combos="rangeTableCell"
                  :asEmpty="true"
                  :combosPlayer="rangeTableCell"
                  :bettingInfo="{ pot: 5.5, showEvIn }"
                  :isCentered="false"
                  :grouping="'none'"
                  player="0"
                  rangeKey="range_normalized"
                  valueProp="ev"
                  showProp="strategy"
                  :solProps="rtcSolProps"
                />
                <RangeTableCell
                  class="no-events ursetappr_rtc"
                  :combos="rangeTableCell"
                  :combosPlayer="rangeTableCell"
                  :bettingInfo="{ pot: 5.5, showEvIn }"
                  :useHex="false"
                  :isCentered="false"
                  :grouping="'none'"
                  :noValue="!showHandValue"
                  player="0"
                  rangeKey="range_normalized"
                  valueProp="ev"
                  showProp="strategy"
                  :solProps="rtcSolProps"
                />
              </div>
              <RangeTableCell
                class="no-events ursetappr_rtc ursetappr_rtc_active"
                :combos="rangeTableCell"
                :active="true"
                style=""
                :combosPlayer="rangeTableCell"
                :isCentered="false"
                :noValue="true"
                :grouping="'none'"
                :useHex="false"
                player="0"
                rangeKey="range_full_height"
                valueProp="strategy"
                showProp="strategy"
                :solProps="rtcSolProps"
              />
            </div>

            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('common.hand_table_cell') }}
            </div>
            <div
              class="ursetappr_rtc-container ursetappr_preview"
              style="--legend-font-size: 1rem"
            >
              <HandTableCell
                class="no-events ursetappr_htc"
                :combo="handTableCell"
                :asEmpty="true"
                :comboPlayer="handTableCell"
                :isCentered="false"
                :grouping="'none'"
                player="0"
                rangeKey="range_normalized"
                valueProp="ev"
                showProp="strategy"
                :solProps="rtcSolProps"
                :hasBlockers="false"
              />
              <HandTableCell
                class="no-events ursetappr_htc"
                :combo="handTableCell"
                :comboPlayer="handTableCell.players[0]"
                :isCentered="false"
                :grouping="'none'"
                player="0"
                rangeKey="range_normalized"
                valueProp="ev"
                showProp="strategy"
                :solProps="rtcSolProps"
                :customGroupingActive="true"
                :hasBlockers="false"
              />
            </div>
          </div>
        </div>
      </template>
      <template #content_other>
        <div class="d-flex mh-0">
          <div class="ursetappr_block ursetappr_block_normal ursetappr_block_scroll f-column">
            <SettingsBetInPercent :hasPreview="false" />
            <SettingsEvIn
              :hasPreview="false"
              class="mt-4"
            />
            <SettingsEvIcmIn
              :hasPreview="false"
              class="mt-4"
            />
            <SettingsEqbucketsStyle
              :hasPreview="false"
              class="mt-4"
            />
            <SettingsActionsGrouping
              :hasPreview="false"
              class="mt-4"
            />
            <div class="theme-block-title mt-6">
              {{ $t('common.strategy') }}
            </div>
            <SettingsCheckbox
              settingsKey="showLoadingTips"
              class="ursetappr_right_item"
              :title="$t('settings.show_loading_tips')"
              :tooltip="$t('tooltips.show_loading_tips')"
            />
            <SettingsCheckbox
              settingsKey="showLegacySolutions"
              class="ursetappr_right_item mt-2"
              :title="$t('settings.show_legacy_solutions')"
              :tooltip="$t('tooltips.show_legacy_solutions')"
              :customSet="customSetLegacySolutions"
            />
            <SettingsCheckbox
              settingsKey="keepFiltersBetweenSpots"
              class="ursetappr_right_item mt-2"
              :title="$t('settings.keep_filters_between_spots')"
              :tooltip="$t('tooltips.keep_filters_between_spots')"
            />
          </div>
          <div class="ursetappr_block_preview bl-grey">
            <div class="text-small uppercase clr-grey pb-2">
              {{ $t('common.preview') }}
            </div>
            <div class="text-small clr-grey pb-2">
              {{ $t('settings.show_bets_in') }}
            </div>
            <SettingsBetInPercent
              :hasOptions="false"
              :hasKey="false"
              :hasTitle="false"
            />
            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.show_ev_in') }}
            </div>
            <SettingsEvIn
              :hasOptions="false"
              :hasKey="false"
              :hasTitle="false"
            />
            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.show_ev_icm_in') }}
            </div>
            <SettingsEvIcmIn
              :hasOptions="false"
              :hasKey="false"
              :hasTitle="false"
            />
            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.range_eq_buckets_style_title') }}
            </div>
            <SettingsEqbucketsStyle
              :hasOptions="false"
              :hasTitle="false"
            />
            <div class="text-small clr-grey pb-2 mt-4">
              {{ $t('settings.grouping_actions') }}
            </div>
            <SettingsActionsGrouping
              :hasOptions="false"
              :hasTitle="false"
              :hasPersist="false"
            />
          </div>
        </div>
      </template>

      <template #[afterSlotName]>
        <div class="ursetappr_appearance_right bl-grey">
          <GwTitleTooltip
            :tooltip="$t('tooltips.color_themes')"
            :title="$t('common.themes')"
            style="padding: 0 0 1.5rem 0"
          >
            <div
              class="text-smallest text-italic"
              style="position: absolute; bottom: 0.375rem"
              v-html="$t('messages.more_themes_on_discord')"
            ></div>
          </GwTitleTooltip>
          <ColorPalettes
            class="ursetappr_right_item f-column"
            style="--clr-btns-back: var(--clr-palettes-btns-back)"
          />
        </div>
      </template>
    </TabsContentTemplate>
  </div>
</template>

<script>
import TabsContentTemplate from '@/components/TabsContentTemplate/TabsContentTemplate.vue'
import PokerPlayer from '@/components/PokerTable/PokerPlayer.vue'
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton.vue'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip.vue'
import RangeTableCell from '@/components/Study/RangeTableCell.vue'
import HandTableCell from '@/components/Study/HandTableCell.vue'
import PokerCard from '@/components/Poker/PokerCard/PokerCard.vue'
import SettingsTextOutline from '@/components/Dialogs/UserSettingsDialog/SettingsTextOutline.vue'
import ColorPalettes from '@/components/Dialogs/UserSettingsDialog/ColorPalettes.vue'
import SettingsColors from '@/components/Dialogs/UserSettingsDialog/SettingsColors.vue'
import SettingsCardsStyle from '@/components/Dialogs/UserSettingsDialog/SettingsCardsStyle.vue'
import SettingsHeroTableSeats from '@/components/Dialogs/UserSettingsDialog/SettingsHeroTableSeats.vue'
import SettingsBetInPercent from '@/components/Dialogs/UserSettingsDialog/SettingsBetInPercent.vue'
import SettingsEvIn from '@/components/Dialogs/UserSettingsDialog/SettingsEvIn.vue'
import SettingsEvIcmIn from '@/components/Dialogs/UserSettingsDialog/SettingsEvIcmIn.vue'
import SettingsEqbucketsStyle from '@/components/Dialogs/UserSettingsDialog/SettingsEqbucketsStyle.vue'
import SettingsActionsGrouping from '@/components/Dialogs/UserSettingsDialog/SettingsActionsGrouping.vue'
import SettingsTrainerBackPattern from '@/components/Dialogs/UserSettingsDialog/SettingsTrainerBackPattern.vue'
import TrainerBackPattern from '@/components/Trainer/TrainerBackPattern.vue'
import NavBox from '@/components/NavBox/NavBox.vue'
import ChartLegendPlayers from '@/components/Charts/LineCharts/ChartLegendPlayers.vue'
import SettingsCheckbox from '@/components/Dialogs/UserSettingsDialog/SettingsCheckbox.vue'

import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import { getPlayersDefault } from '@/store/gamestate/gamestate'
import elementsMock from './elementsMock.json'
import { getRangeTableMock } from './raTableMock'

export default {
  name: 'UserAppearance',
  components: {
    TabsContentTemplate,
    PokerPlayer,
    PokerTableSkeleton,
    SettingsHeroTableSeats,
    GwTitleTooltip,
    RangeTableCell,
    HandTableCell,
    PokerCard,
    SettingsTextOutline,
    ColorPalettes,
    SettingsColors,
    SettingsCardsStyle,
    SettingsBetInPercent,
    SettingsEvIn,
    SettingsEvIcmIn,
    SettingsEqbucketsStyle,
    SettingsActionsGrouping,
    SettingsTrainerBackPattern,
    TrainerBackPattern,
    NavBox,
    ChartLegendPlayers,
    SettingsCheckbox,
  },
  mixins: [format_mix, float_mix],
  data() {
    this.rangeTableMock = getRangeTableMock()
    this.rangeTableCell = elementsMock.rtc
    this.handTableCell = elementsMock.htc
    this.rtcSolProps = {
      study_filter_actions: false,
      filterActionsLength: 0,
      study_range_full_height: false,
      study_range_normalized: true,
      study_combos_columns: false,
      combos_columns_line: false,
      study_solution_tab: 'strategy',
      study_solution_tabs_fullscreen: false,
      '0_total_ev': 1,
      '1_total_ev': 1,
      study_card_table_cell_legend_value: true,
    }
    return {}
  },
  methods: {
    customSetLegacySolutions(value) {
      this.$store.dispatch('gameformat_set_legacy', {
        showLegacySolutions: value,
      })
    },
  },
  computed: {
    sections() {
      return [
        {
          id: 'colors',
          title: this.$t('common.colors'),
        },
        {
          id: 'trainer',
          title: this.$t('common.trainer'),
        },
        {
          id: 'cards',
          title: this.$t('common.cards'),
        },
        {
          id: 'text_and_backgrounds',
          title: this.$t('settings.text_and_backgrounds'),
        },
        {
          id: 'preferred_seat',
          title: this.$t('common.preferred_seat'),
        },
        {
          id: 'other',
          title: this.$t('common.other'),
        },
      ]
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    showBetsIn() {
      const { show_bets_in } = this.$store.getters
      return show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
    mergedUserSettings() {
      const { mergedUserSettings } = this.$store.getters
      return mergedUserSettings
    },
    showHandValue() {
      return this.mergedUserSettings.showHandValue
    },
    trainerTableColors() {
      return this.mergedUserSettings.trainerTableColors
    },
    actionsColors() {
      return this.mergedUserSettings.actionsColors
    },
    otherColors() {
      return this.mergedUserSettings.otherColors
    },
    typographyColors() {
      return this.mergedUserSettings.typographyColors
    },
    suitsColors() {
      return this.mergedUserSettings.suitsColors
    },
    ipOopColors() {
      return this.mergedUserSettings.ipOopColors
    },
    l_players() {
      const gameformat = { players: 4 }
      const res = getPlayersDefault({ gameformat })
        .filter((_, idx) => idx <= 3)
        .map((i, idx) => {
          i.position =
            idx === 0
              ? this.$t('common.hero')
              : idx === 1
                ? this.$t('common.gto')
                : idx === 3
                  ? this.$t('common.folded')
                  : this.$t('common.non_folded')
          return i
        })
        .map((i, idx) => ({
          ...i,
          is_dealer: false,
          is_active: idx === 0 || idx === 1,
          is_bot: idx === 1,
          is_folded: idx === 3,
        }))
      // console.log(res)
      return res
    },
    afterSlotName() {
      return this.mobile ? 'after' : 'content_after'
    },
  },
}
</script>

<style lang="scss">
.ursetappr {
  display: flex;
  --padding-left: 1rem;
  --padding-right: 1rem;
  --clr-palettes-btns-back: var(--clr-black-1);

  --set-oveflow-x: hidden;
  --set-oveflow-y: hidden;

  min-width: 0;
  min-height: 0;
  flex: 1;

  &_block {
    padding: 1rem;
    position: relative;
    &_normal {
      width: 100%;
      min-width: 22.5rem;
    }
    &_scroll {
      overflow-x: hidden;
      overflow-y: auto;
    }
    &_preview {
      min-width: 22.5rem;
      max-width: 22.5rem;
      top: 0;
      padding: 1rem;
      width: 100%;
      background: var(--clr-black-1-1);
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  &_preview {
    padding: 0rem 0 1rem 0;
    position: relative;
    z-index: 1;
    max-width: 100%;
  }
  &_appearance {
    display: flex;
    min-height: 0;
    overflow: hidden;
    .ursetappr_right_item {
      padding: 0;
    }
    &_left {
      padding: var(--padding-left);
      overflow-x: hidden;
      overflow-y: auto;
      flex: 1;
      flex-shrink: 0;
    }
    &_right {
      padding: var(--padding-right);
      overflow-x: hidden;
      overflow-y: auto;
      flex-shrink: 0;
      width: 16rem;
    }
  }
  .appearance-trainer-pattern {
    top: -6rem;
    left: calc(-50% - 2rem);
    height: 24rem;
    overflow: hidden;
    width: calc(200% + 4rem);
    transform: scale(0.5);
    background: var(--clr-canvas-back);

    border-radius: 8px;
    overflow: hidden;
  }
  &_trainer-container {
    display: flex;
    min-height: 12rem;
    min-width: 18rem;
    padding: 1rem 0 1rem 0;
    position: relative;
    z-index: 1;
    --clr-canvas-back: var(--clr-trainer_canvas_back);

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      height: 100%;
      width: calc(100% + 2rem);
      border-radius: 8px;
      left: -1rem;
    }
    &:before {
      content: '';
      background: var(--clr-black-0);
      z-index: -1;
    }
    &:after {
      content: '';
      z-index: 1;
      border: solid 2px var(--clr-trainer_canvas_outline);
      box-sizing: border-box;
    }
    &_active {
      --clr-canvas-back: var(--clr-trainer_active_canvas_back);
      &:after {
        content: '';
        border: solid 2px var(--clr-trainer_active_canvas_outline);
        box-sizing: border-box;
        border-radius: 4px;
      }
    }
  }
  &_rtc-container {
    display: flex;
    grid-gap: 0.5rem;
  }
  &_rtc {
    border-radius: 8px !important;
    border: 1px solid var(--clr-black-0);
    &:not(.ursetappr_rtc_active) {
      height: 6rem !important;
      width: 6rem !important;
    }
    &_active {
      height: 12.5rem !important;
      width: 12.5rem !important;
      box-shadow: none !important;
      top: 0 !important;
    }
  }
  &_htc {
    border-radius: 8px !important;
    border: 1px solid var(--clr-black-0);
    height: 9.25rem !important;
    width: 9.25rem !important;
    box-shadow: none !important;
  }
  .appr-pack-row {
    display: flex;
    align-self: flex-start;
    max-width: 100%;
    grid-gap: 0.25rem;
    .poker-card {
      margin: 0;
    }
  }
}
.appr-mocked-action-btn {
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: var(--action-btn-text-shadow);
  color: var(--clr-action_text);
  --clr-back: var(--clr-R_default);
  background: var(--clr-back);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 1.25rem;
  position: relative;
  overflow: hidden;
}
.appr-ra_table {
  border: solid 1px var(--clr-black-0);
  background: var(--clr-black-0);
  display: grid;
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: repeat(13, 1fr);
  grid-gap: 1px;
  border-radius: 4px;
  overflow: hidden;

  min-height: 12rem;
  min-width: 14rem;

  .appr-rtc_local {
    background-repeat: no-repeat;
    background-position-y: 100%;
    position: relative;
    z-index: 0;
    background-color: var(--clr-black-1);
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
}

@media screen and (max-width: 1300px) {
  .ursetappr {
    --set-oveflow-x: auto;
    --set-oveflow-y: hidden;
  }
}

@media (max-width: 620px) {
  .ursetappr {
    overflow: auto;
    &_appearance {
      flex-direction: column;
      max-height: unset;
      &_left {
        grid-template-columns: 1fr;
      }
      &_right {
        border-left: none !important;
      }
    }
  }
}
</style>
